import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { Link } from "react-router-dom";
import { GoChevronLeft, GoChevronRight } from "react-icons/go";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "swiper/css";
import "swiper/css/navigation";
import { getBannerOfferList } from "../../../api/services";

const Offers = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetchBannerOffers();
  }, []);

  const fetchBannerOffers = async () => {
    try {
      setLoading(true);
      const res = await getBannerOfferList();
      setOffers(res?.data?.data || []);
    } catch (error) {
      console.error("Error fetching banner:", error);
    } finally {
      setLoading(false);
    }
  };
  const showNavigation = offers.length > 3;

  return (
    <div className="offer_boxes_wrap offer_boxes_wrap-two pb-5">
      <div className="container">
        <div className="row center">
          <div className="col-12" style={{ position: "relative" }}>
            {/* SHOW BUTTON ONLY IF MORE THAN 3 */}
            {showNavigation && (
              <>
                <div
                  ref={prevRef}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "-5px",
                    transform: "translateY(-50%)",
                    zIndex: 10,
                    background: "#fff",
                    borderRadius: "50%",
                    padding: "8px",
                    cursor: "pointer",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                    width: "40px",
                    height: "40px",
                  }}
                >
                  <GoChevronLeft size={22} />
                </div>

                <div
                  ref={nextRef}
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "-5px",
                    transform: "translateY(-50%)",
                    zIndex: 10,
                    background: "#fff",
                    borderRadius: "50%",
                    padding: "8px",
                    cursor: "pointer",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                    width: "40px",
                    height: "40px",
                  }}
                >
                  <GoChevronRight size={22} />
                </div>
              </>
            )}

            <Swiper
              slidesPerView={3}
              spaceBetween={20}
              loop={!loading && offers.length > 3}
              autoplay={
                !loading
                  ? {
                      delay: 3000,
                      disableOnInteraction: false,
                    }
                  : false
              }
              navigation={
                !loading && showNavigation
                  ? {
                      prevEl: prevRef.current,
                      nextEl: nextRef.current,
                    }
                  : false
              }
              modules={[Navigation, Autoplay]}
              onInit={(swiper) => {
                if (!loading && showNavigation) {
                  swiper.params.navigation.prevEl = prevRef.current;
                  swiper.params.navigation.nextEl = nextRef.current;
                  swiper.navigation.init();
                  swiper.navigation.update();
                }
              }}
              breakpoints={{
                320: { slidesPerView: 1 },
                576: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
              }}
            >
              {loading
                ? Array(3)
                    .fill(0)
                    .map((_, index) => (
                      <SwiperSlide key={index}>
                        <div className="offer_box_inner">
                          {/* Skeleton Image */}
                          <div
                            style={{
                              width: "100%",
                              height: "250px",
                              borderRadius: "15px",
                              overflow: "hidden",
                            }}
                          >
                            <Skeleton height="100%" width="100%" />
                          </div>
                        </div>
                      </SwiperSlide>
                    ))
                : offers.map((offer) => (
                    <SwiperSlide key={offer.id}>
                      <div className="offer_box_inner">
                        <div className="offer_box_img">
                          <Link to="#">
                            <img
                              src={offer.image}
                              alt="offer-banner"
                              loading="lazy"
                              style={{ borderRadius: 15, width: "100%" }}
                            />
                          </Link>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Offers;
